/**
 * Given a log event, return true if the event represents a failure.
 * The backend uses two different strings to represent log event failures.
 * @param {LogEvent} event
 * @returns {boolean}
 */
export const isLogEventFailure = (event: LogEvent): boolean =>
    ['failed', 'failure'].includes(event.eventStatus);
